export class AddUserToGroupRequest {
	constructor(
		public lockSerialNumber: string = '',
		public lockUserIds: number[] = [],
		public lockUserGroupName: string = '',
		public groupName: string = '',
		public created: string = ''
	) { }
}
